<template>
  <div>
    <div class="container" v-if="advances">
      <div class="card">
        <div class="title">
          <van-image width="30" height="32px" :src="advancesImg" />
          <span style="flex: 1; font-size: 15px;line-height: 24px;">{{advances.contractName}}</span>
        </div>
        <div class="tag_box">
          <van-tag plain type="primary">垫款类型:{{ formatHandel('advancesType',advances.advancesType) || '-' }}</van-tag>
          <van-tag plain :type="advances.checkStatus == '0'?'success':advances.checkStatus == '1'?'warning':'primary'" v-if="advances.checkStatus || advances.checkStatus == '0'">流程:{{ advancesArr[advances.checkStatus] }}</van-tag>
          <br />
          <van-tag plain :type="advances.isExpectDate == 0?'primary':'warning'" >是否逾期:{{ advances.isExpectDate == 0?'正常':'逾期' }}</van-tag>
          <van-tag v-if="advances.checkStatus === 6" plain :type="advances.payStatus == 0?'danger':advances.payStatus == 1?'warning':'primary'" >本次回款:{{ advances.payStatus == 0?'未回款':advances.payStatus == 1?'部分回款':'全部回款' }}</van-tag>
        </div>
        <div style="background-color: #f4f4f4;width: 100%;height: 5px;margin-top: 10px;"></div>
        <van-tabs v-model="active" @click="tabClick">
          <van-tab title="垫款信息">
            <van-divider content-position="left" :style="{ color: '#1989fa', borderColor: '#1989fa', fontWeight: 'bold' }">合同信息</van-divider>
            <div class="list-wrap van-hairline--top">
              <div class="item" >
                <span class="key">合同编号：</span>
                <span class="value">{{ advances.contractNum }}</span>
              </div>
              <div class="item" style="padding-left:125px;text-indent:-125px;">
                <span class="key">我方签约主体机构：</span>
                <span class="value">{{ advances.companyName }}</span>
              </div>
              <div class="item" >
                <span class="key">合同执行时间：</span>
                <span class="value">{{ advances.startTime }}至{{ advances.endTime }}</span>
              </div>
              <div class="item" v-if="advances.custSource == 2">
                <span class="key" style="color: #1989fa !important;">执行客户：</span>
                <span class="value" style="color: #1989fa;">{{ advances.execCustomerName }}</span>
              </div>
              <div class="item" style="width: 50%;">
                <span class="key">客户来源：</span>
                <span class="value">{{ formatHandel('custSource',advances.custSource) || '-' }}</span>
              </div>
              <div class="item" style="width: 50%;">
                <span class="key">框架类型：</span>
                <span class="value">{{ formatHandel('frameType',advances.frameType) }}</span>
              </div>
              <div class="item">
                <span class="key">合同金额(元)：</span>
                <span class="value">￥{{ advances.contractMoney || '0' }}</span>
              </div>
              <div class="item" >
                <span class="key">合同累计垫款回款(元)：</span>
                <span class="value">￥{{ advances.inMoney || '0' }}</span>
              </div>
              <div class="item">
                <span class="key">累计垫款未回款(元)：</span>
                <span class="value">￥{{ advances.noReturnedMoney }}</span>
              </div>
              <div class="item" style="width: 50%;">
                <span class="key">垫款方式：</span>
                <span class="value">{{ formatHandel('payType',advances.payType) }}</span>
              </div>
              <!-- <div class="item" style="width: 50%;">
                <span class="key">授信账期：</span>
                <span class="value">{{advances.creditCycleType?`${advances.creditCycleValue}个${formatHandel('creditCycleType',advances.creditCycleType)}`:'--'}}</span>
              </div> -->
            </div>
            <van-divider content-position="left" :style="{ color: '#1989fa', borderColor: '#1989fa', fontWeight: 'bold' }">额度信息</van-divider>
            <div class="list-wrap van-hairline--top">
              <div class="item" v-if="advances.payType == 2">
                <span class="key">合同授信总额(元)：</span>
                <span class="value">￥{{ advances.advancesMoney }}</span>
              </div>
              <!-- <div class="item" v-if="advances.payType == 2">
                <span class="key">累计垫款总额(元)：</span>
                <span class="value">￥{{ advances.creditTotalMoney }}</span>
              </div> -->
              <div class="item" v-if="advances.payType == 2">
                <span class="key">剩余授信总额(元)：</span>
                <span class="value">￥{{ advances.advancesMoney - advances.creditTotalMoney }}</span>
              </div>
              <div class="item" v-if="advances.payType == 1">
                <span class="key">部门临时垫款总额度(元)：</span>
                <span class="value">￥{{ advances.deptAdvancesTotal }}</span>
              </div>
              <div class="item" v-if="advances.payType == 1">
                <span class="key">累计部门临时垫款总额(元)：</span>
                <span class="value">￥{{ advances.deptAdvancesTotalAdd }}</span>
              </div>
              <div class="item" v-if="advances.payType == 1" >
                <span class="key">剩余部门临时授信总额(元)：</span>
                <span class="value">￥{{ advances.deptAdvancesTotal - advances.deptAdvancesTotalAdd }}</span>
              </div>
            </div>
            <van-divider content-position="left" :style="{ color: '#1989fa', borderColor: '#1989fa', fontWeight: 'bold' }">申请信息</van-divider>
            <div class="list-wrap van-hairline--top">
              <!-- <div class="item" style="width: 50%;">
                <span class="key">垫款类型：</span>
                <span class="value">{{ formatHandel('advancesType',advances.advancesType) || '-' }}</span>
              </div> -->
              <!-- <div class="item">
                <span class="key">本次回款状态：</span>
                <span class="value">
                  <span v-if="advances.payStatus == 0">未回款</span>
                  <span v-if="advances.payStatus == 1">部分回款</span>
                  <span v-if="advances.payStatus == 2">全部回款</span>
                </span>
              </div> -->
              <div class="item">
                <span class="key">本次垫款金额(元)：</span>
                <span class="value">￥{{ advances.payMoney1 }}</span>
              </div>
              <div class="item">
                <span class="key">垫款周期：</span>
                <span class="value">{{advances.creditCycleType?`${advances.creditCycleValue}个${formatHandel('creditCycleType',advances.creditCycleType)}`:'--'}}</span>
              </div>
              <div class="item">
                <span class="key">垫款时间：</span>
                <span class="value">{{ advances.checkTime }}</span>
              </div>
              <div class="item" >
                <span class="key">客户确认充值图片：</span>
                <van-button type="info" size="mini" plain v-if="advances.rechargeImg" @click="showImg('rechargeImg')">点击查看</van-button>
                <span class="value" v-else>无</span>
              </div>
              <div class="item" style="padding-left:70px;text-indent:-70px;">
                <span class="key">垫款事由：</span>
                <span class="value">{{ advances.advancesReason }}</span>
              </div>
              <div class="item">
                <span class="key">到期回款时间：</span>
                <span class="value">{{ advances.expectPayDate || '-' }}</span>
              </div>
              <div class="item" v-if="advances.checkStatus == 4 || advances.checkStatus == 5 || advances.checkStatus == 6">
                <span class="key">充值过期时间：</span>
                <span class="value">{{ advances.rechargeTime || '--' }}</span>
              </div>
              <div class="item" v-if="advances.checkStatus == 4 || advances.checkStatus == 5 || advances.checkStatus == 6">
                <span class="key">充值剩余金额：</span>
                <span class="value">￥{{ advances.rechargeRemainMoney || '--' }}</span>
              </div>
              <div class="item" >
                <span class="key">申请信息：</span>
                <span class="value">{{ advances.deptName }}<span style="margin-left: 5px;color: #1989fa">{{ advances.custSource === 2?advances.addUserName:advances.userName }}</span></span>
              </div>
              <div class="item" style="padding-left:70px;text-indent:-70px;">
                <span class="key">企微垫款状态标签：</span>
                <span class="value">{{ advances.advanceStatusLab || '无' }}</span>
              </div>
              <div class="item" v-if="isJudge" >
                <span class="key">逾期原因：</span>
                <span class="value">{{ advances.exceedTimeReason }}</span>
              </div>
              <div class="item" v-if="isJudge" >
                <span class="key">延迟还款承诺书：</span>
                <van-button type="info" size="mini" plain v-if="advances.delayedCommitmentFile" @click="showImg('delayedCommitmentFile')">点击查看</van-button>
                <span class="value" v-else>无</span>
              </div>
            </div>
          </van-tab>
          <van-tab title="垫款日志">
            <div class="item">
              <van-steps direction="vertical" :active="100" active-color="#c8c9cc">
                <van-step v-for="(item,index) in operationLogList" :key="index">
                  <span style="font-weight: bold">{{item.remark}}</span>
                  <span style="margin-left: 8px">{{item.createTime}}</span>
                  <log-examine :logExamineArr="item.listData"></log-examine>
                </van-step>
              </van-steps>
            </div>
          </van-tab>
          <van-tab title="回款记录">
            <div class="item">
              <van-list :finished="true" finished-text="没有更多了"  @load="getReturnList" v-if="returnList.length > 0">
                <van-cell v-for="(item,index) in returnList" :key="index">
                  <div class="flex-between" v-if="item" style="align-items: flex-start">
                    <div style="max-width: 80%">
                      <div>
                        <span class="key">回款金额(元)：</span>
                        <span class="value">{{ item.payMoney }}</span>
                      </div>
                      <div>
                        <span class="key"> 回款时间：</span>
                        <span class="value">{{ item.createTime }}</span>
                      </div>
                    </div>
                  </div>
                </van-cell>
              </van-list>
              <empty v-if="returnList.length == 0" />
            </div>
          </van-tab>
          <van-tab title="逾期信息" v-if="isJudge">
            <div class="item">
              <van-list :finished="true" finished-text="没有更多了"  @load="getOverdueList" v-if="overdueList.length > 0">
                <van-cell v-for="(item,index) in overdueList" :key="index">
                  <div class="flex-between" v-if="item" style="align-items: flex-start">
                    <div style="max-width: 80%">
                      <div>
                        <span class="key"> 垫款时间：</span>
                        <span class="value">{{ item.checkTime }}</span>
                      </div>
                      <div >
                        <span class="key"> 垫款金额(元)：</span>
                        <span class="value">{{ item.payMoney }}</span>
                      </div>
                      <div >
                        <span class="key"> 已还款金额(元)：</span>
                        <span class="value">{{ item.inMoney }}</span>
                      </div>
                      <div>
                        <span class="key"> 逾期时间：</span>
                        <span class="value">{{ item.expectPayDate }}</span>
                      </div>
                      <div>
                        <span class="key"> 逾期金额：</span>
                        <span class="value">{{ item.payMoney - item.inMoney }}</span>
                      </div>
                    </div>
                  </div>
                </van-cell>
              </van-list>
              <empty v-if="overdueList.length == 0" />
            </div>
          </van-tab>
        </van-tabs>
      </div>
      <!-- 操作按钮区 -->
      <van-grid class="grid-wrap" :column-num="2" v-if="advances.checkStatus == 0 || advances.checkStatus == 1">
        <van-grid-item>
          <div class="flex-center" @click="handleUpdate">
            <van-icon name="edit" size="22" color="#07c160" />
            <span>修改</span>
          </div>
        </van-grid-item>
        <van-grid-item>
          <div class="flex-center" @click="handleDelete">
            <van-icon name="delete" size="22" color="#ee0a24" />
            <span>删除</span>
          </div>
        </van-grid-item>
      </van-grid>
      <van-grid class="grid-wrap" :column-num="1" v-hasPermi="['cont:advances:cancel']" v-if="advances.checkStatus != 0 && advances.checkStatus != 1 && advances.checkStatus != 6">
        <van-grid-item>
          <div class="flex-center" @click="handleRevoke">
            <van-icon name="revoke" size="22" color="#ee0a24" />
            <span>撤回</span>
          </div>
        </van-grid-item>
      </van-grid>
      <van-grid class="grid-wrap" :column-num="1">
        <van-grid-item v-if="advances.checkStatus == 0 || advances.checkStatus == 1">
          <div class="flex-center" @click="handleCg">
            <van-icon name="sign" size="22" color="#1989fa" />
            <span>提交草稿</span>
          </div>
        </van-grid-item>
        <van-grid-item v-if="advances.checkStatus == 2">
          <div class="flex-center" v-hasPermi="['cont:advances:deptAudit']" @click="handleBmsh">
            <van-icon name="sign" size="22" color="#1989fa" />
            <span>部门审核</span>
          </div>
        </van-grid-item>
        <van-grid-item v-if="advances.checkStatus == 4">
          <div class="flex-center" v-hasPermi="['cont:advances:confrimBuss']" @click="handleYwy">
            <van-icon name="certificate" size="22" color="#1989fa" />
            <span>业务员确认</span>
          </div>
        </van-grid-item>
        <van-grid-item v-if="advances.checkStatus == 5 && (advances.operationUserId == $store.state.user.user.userId)">
          <div class="flex-center" v-hasPermi="['cont:advances:confrimOpt']" @click="handleYy">
            <van-icon name="passed" size="22" color="#1989fa" />
            <span>媒介确认</span>
          </div>
        </van-grid-item>
        <!-- <van-grid-item v-if="advances.checkStatus == 6">
          <div class="flex-center" v-hasPermi="['cont:advances:finaPay']">
            <van-icon name="cash-back-record" size="22" color="#1989fa" />
            <span @click="handleCwdk">财务打款确认</span>
          </div>
        </van-grid-item> -->
      </van-grid>
      <van-grid class="grid-wrap" :column-num="1">
        <van-grid-item>
          <div class="flex-center" @click="handleDetails">
            <van-icon name="more-o" size="22" color="#ff976a" />
            <span>合同详情</span>
          </div>
        </van-grid-item>
      </van-grid>
      <!-- <van-grid class="grid-wrap" :column-num="1" v-if="advances.isRecharge == 1 && advances.rechargeRemainMoney > 0 && (advances.checkStatus == 4 || advances.checkStatus == 5 || advances.checkStatus == 6)">
        <van-grid-item>
          <div class="flex-center" @click="handleRecharge">
            <van-icon name="cash-back-record" size="22" color="#07c160" />
            <span>充值申请</span>
          </div>
        </van-grid-item>
      </van-grid> -->
      <!-- 操作按钮区 -->
      <van-grid class="grid-wrap" :column-num="1" v-if="$route.query.type && advances.checkStatus == 2">
        <van-grid-item>
          <div class="flex-center" @click="handleNext">
            <span>部门审核确认并下一条</span>
            <van-icon name="arrow" size="18" color="#1989fa" />
          </div>
        </van-grid-item>
      </van-grid>
    </div>
    <van-image-preview v-model="imageShow" :images="imageArr">
    </van-image-preview>
    <!-- 部门审核 -->
    <van-dialog v-model="bmshVisible" title="部门审核" width="90%" class="editVisit" :beforeClose="bmshBeforeClose" close-on-click-overlay show-cancel-button>
      <van-form ref="bmshForm" validate-trigger="onSubmit" class="formSty">
        <van-cell-group>
          <van-cell title="审核：" required>
            <template>
              <van-radio-group v-model="bmshForm.checkStatus" direction="horizontal">
                <van-radio name="2" clickable @click="bmshForm.checkStatus = '2'">通过</van-radio>
                <van-radio name="1" clickable @click="bmshForm.checkStatus = '1'">不通过</van-radio>
              </van-radio-group>
            </template>
          </van-cell>
          <van-field v-model="bmshForm.checkReason"
            autosize
            label="备注"
            placeholder="请输入审核备注"
            type="textarea"
            show-word-limit
            :required="bmshForm.checkStatus == 1 ? true : false"
            :rules="bmshForm.checkStatus == 1 ? [{ required: true }] : []"/>
        </van-cell-group>
      </van-form>
    </van-dialog>

    <!-- 业务员确认 -->
    <van-dialog v-model="ywyVisible" title="业务员确认" width="90%" class="editVisit" :beforeClose="ywyBeforeClose" close-on-click-overlay show-cancel-button>
      <van-form ref="ywyForm" validate-trigger="onSubmit" class="formSty">
        <van-field readonly clickable v-model="ywyForm.operationDeptName" label="部门" @click="showCascader('dept')" :rules="[{ required: true }]" placeholder="请选择部门" required />
        <van-field readonly clickable v-model="ywyForm.operationUserName" label="媒介人员" @click="ywyForm.operationDeptId?showPicker('userName'):''" placeholder="请先选择部门再选择媒介人员" :rules="[{ required: true }]" required />
        <van-field v-model="ywyForm.checkReason"
            autosize
            label="备注"
            placeholder="请输入备注"
            type="textarea"
            show-word-limit />
      </van-form>
    </van-dialog>

    <!-- 媒介确认 -->
    <van-dialog v-model="yyqrVisible" title="媒介确认" width="90%" class="editVisit" :beforeClose="yyqrBeforeClose" close-on-click-overlay show-cancel-button>
      <van-form ref="yyqrForm" validate-trigger="onSubmit" class="formSty">
        <van-cell-group>
          <van-cell title="审核：" required>
            <template>
              <van-radio-group v-model="yyqrForm.checkStatus" direction="horizontal">
                <van-radio name="5" clickable @click="yyqrForm.checkStatus = '5'">通过</van-radio>
                <van-radio name="6" clickable @click="yyqrForm.checkStatus = '6'">不通过</van-radio>
              </van-radio-group>
            </template>
          </van-cell>
          <van-field v-model="yyqrForm.checkReason"
            autosize
            label="备注"
            placeholder="请输入审核备注"
            type="textarea"
            show-word-limit
            :required="yyqrForm.checkStatus == 6 ? true : false"
            :rules="yyqrForm.checkStatus == 6 ? [{ required: true }] : []"/>
        </van-cell-group>
      </van-form>
    </van-dialog>

    <!-- 财务打款确认 -->
    <van-dialog v-model="cwdkVisible" title="财务打款确认" width="90%" class="editVisit" :beforeClose="cwdkBeforeClose" close-on-click-overlay show-cancel-button>
      <van-form ref="cwdkForm" validate-trigger="onSubmit" class="formSty">
        <van-field readonly clickable v-model="cwdkForm.contPayCompanyName" @click="showPicker('company')" label="垫款单位" placeholder="请选择垫款单位" :rules="[{ required: true }]" required />
        <van-field readonly clickable v-model="cwdkForm.payBankAccountName" @click="cwdkForm.contPayCompanyName?showPicker('incomeBank'):''" label="垫款银行" :rules="[{ required: true }]" placeholder="请先选择垫款单位再选择垫款银行" required />
        <van-field v-model="cwdkForm.bankId" label="垫款银行账号" type="number" placeholder="请先选择垫款银行" disabled required />
        <van-field v-model="cwdkForm.checkReason"
            autosize
            label="备注"
            placeholder="请输入备注"
            type="textarea"
            show-word-limit />
      </van-form>
    </van-dialog>

    <van-popup v-model="picker.visible" position="bottom">
      <van-search v-model="authIdQuery.accountId" placeholder="请输入账户ID查询" @search="onSearch" @input="onSearch" v-if="picker.formKey == 'accountNo'" />
      <van-picker :title="picker.title" show-toolbar :columns="picker.columns" @confirm="pickerConfirm" @cancel="pickerCancel" @change="pickerChange" />
    </van-popup>
    <van-popup v-model="tree.typeTree" position="bottom">
      <van-cascader :title="tree.title" :options="tree.treeList" :field-names="tree.fieldNames" @change="treeChange" @close="tree.typeTree = false" />
    </van-popup>
    <dialog-advances :show='advancesFormShow' :isAdd="false" :modifyObj="advances" :contractId="advances.contractId" @handleAdvancesCancel='handleAdvancesCancel' @beforeClose='addAdvancesBeforeClose'></dialog-advances>

    <!-- 指定媒介 -->
    <van-dialog v-model="designatedVisible" title="指定媒介" width="95%" style="height:50%" class="media" :beforeClose="saveDesignated" show-cancel-button>
      <van-form ref="designatedForm" validate-trigger="onSubmit" class="dialog-form-wrap" style="height:98%;">
        <!-- @click="showPicker('dept')" -->
        <!-- <van-field readonly clickable v-model="mediaForm.deptName" label="部门" placeholder="请选择部门" :rules="[{ required: true }]" required /> -->
        <van-field readonly clickable v-model="designatedForm.mediaUserName" @click="showPicker('user')" label="媒介人员" placeholder="请选择媒介人员" :rules="[{ required: true }]" required />
      </van-form>
    </van-dialog>
    <!-- 充值申请 -->
    <van-dialog v-model="rechargeVisible" title="充值申请" width="95%" style="height:80%" class="editClue" show-cancel-button>
      <van-form ref="rechargeForm" validate-trigger="onSubmit" class="dialog-form-wrap" style="height:98%;">
        <van-button v-if="rechargeForm.flowList.length == 0" class="authId_topBtn" round block type="primary" native-type="button" size="small" @click="addExecutive">+添加充值明细</van-button>
        <van-collapse v-model="activeNames">
          <van-collapse-item :name="index" v-for="(item,index) in rechargeForm.flowList" :key="index+'01'" style="border-bottom: dashed 2px #1989fa;">
            <template #title>
              <div class="list_title">
                <van-tag type="success" size="large">执行明细({{index + 1}})</van-tag>
                <div style="margin-right: 10px;">
                  <van-icon name="add-o" size="30" color="#07c160" @click.stop="addExecutive" />
                  <van-icon name="delete-o" size="30" color="#ee0a24" @click.stop="delExecutive(index)" />
                </div>
              </div>
            </template>
            <van-field readonly clickable v-model="item.fundTypeName" @click="showPicker('fundType',index)" label="资金类型" placeholder="请选择资金类型" :rules="[{ required: true }]" required />
            <van-field v-if="(item.fundType == '1' || item.fundType == '2') && advances.custSource == 2" v-model="item.execCustomerName" label="执行客户"
              placeholder="请选择执行客户" readonly clickable  :rules="[{ required: true }]" required />
              <!-- @click="showPicker('execCustomers',index)" -->
            <van-field v-if="(item.fundType == 1 || item.fundType == 2) && (advances.custSource != 2 || item.execCustomerId)" v-model="item.projectName" label="项目名称"
              placeholder="请选择项目名称" readonly clickable  @click="showPicker('projects',index)" :rules="[{ required: true }]" required />
            <template v-if="item.fundType == '1' || item.fundType == '2' && item.projectName">
              <van-cell required :border="false">
                <template #title>
                  <div>账户ID
                    <van-tag type="primary" @click.stop="selectAuthIds(index)" class="tag_button" style="margin-left: 30px;">+ID明细</van-tag>
                  </div>
                </template>
              </van-cell>
              <van-field v-model="item.authIds" rows="3" readonly autosize clearable placeholder="请点击按钮填入账户ID" type="textarea" show-word-limit style="border: 1px solid #d4d4d4; border-radius: 5px" :rules="[{ required: true }]" />
              <van-field v-model="item.rechargeMoney" disabled label="账户币" placeholder="请先填入账户ID" type="number" :rules="[{ required: true }]" required />
            </template>
            <van-field v-model="item.payMoney" :disabled="(item.fundType == '1' || item.fundType == '2') || (!item.fundType && item.fundType != 0)" @input="getAllPayMoney(index)" label="充值金额(元)" placeholder="请输入充值金额" type="number" :rules="[{ required: true }]" required >
              <template slot="right-icon">￥</template>
            </van-field>
          </van-collapse-item>
        </van-collapse>
        <div class="money_total" v-if="rechargeForm.flowList.length > 0">
          <div class="total_title">总计</div>
          <div class="totle_divider"></div>
          <div class="item" >
            <span class="key">账户币：</span>
            <span class="value">{{ rechargeForm.rechargeMoney }}</span>
          </div>
          <div class="item" >
            <span class="key">现金金额(元)：</span>
            <span class="value">
              ￥{{rechargeForm.payMoney}}<span style="color: #409EFF;margin-left: 10px;">{{toChineseBig(rechargeForm.payMoney)}}</span>
            </span>
          </div>
        </div>
      </van-form>
      <div class="footer">
        <van-button hairline type="defaut" plain @click="rechargeVisible = false">取消</van-button>
        <van-button hairline type="primary" plain @click="saveRecharge">媒介充值</van-button>
        <van-button hairline type="warning" plain @click="saveRechargeOnline">在线充值</van-button>
      </div>
    </van-dialog>
    <!-- 在线充值 -->
    <van-dialog v-model="onlineVisible" title="在线充值" width="95%" style="height:80%" class="editClue" show-cancel-button>
      <div style="height:103%;">
        <van-collapse v-model="activeNamesOnline">
          <van-collapse-item :name="index" v-for="(item,index) in rechargeForm.execAccountList" :key="index+'01'" style="border-bottom: dashed 2px #1989fa;">
            <template #title>
              <div class="list_title">
                <van-tag type="success" size="large">在线充值({{index + 1}})</van-tag>
              </div>
            </template>
            <van-field readonly clickable v-model="item.serviceName" @click="showPicker('serviceId',index)" label="所属服务商ID" placeholder="请选择所属服务商ID" :rules="[{ required: true }]" required />
            <van-cell title="充值类型：" required>
              <template>
                <van-radio-group v-model="item.mediaRechargeType" direction="horizontal" :disabled="accountType == 2">
                  <van-radio :name="1" clickable @click="setType">直充</van-radio>
                  <van-radio :name="2" clickable @click="setType">子账户子户</van-radio>
                </van-radio-group>
              </template>
            </van-cell>
            <van-field v-if="item.mediaRechargeType === 2" readonly clickable v-model="item.subAccountName" @click="showPicker('subAccountId',index)" label="子账户ID" placeholder="请选择子账户ID" :rules="[{ required: true }]" required />
            <van-field v-if="accountType == 1" readonly clickable v-model="item.tenFundTypeName" @click="showPicker('tenFundType', index)" label="资金账号类型" placeholder="请选择资金账号类型" :rules="[{ required: true }]" required />
            <van-cell :title="'账户ID：' + item.accountNo" />
            <van-cell :title="'账户币：' + item.rechargeMoney" />
            <van-cell :title="'现金金额(元)：' + item.payMoney" />
          </van-collapse-item>
        </van-collapse>
      </div>
      <div class="footer2">
        <van-button hairline type="defaut" plain @click="onlineVisible = false">取消</van-button>
        <van-button hairline type="primary" plain @click="saveOnline">确认充值</van-button>
      </div>
    </van-dialog>

    <van-dialog v-model="resultVisible" class="contract" width="97%" style="height: 80%;overflow: scroll;" title="充值结果" :showConfirmButton = 'false' :close-on-click-overlay="true">
      <van-list class="van-list" style="height: 60%">
        <van-cell v-for="(item,index) in resultList" :key="index">
          <div class="flex-between">
            <div style="color: #333; font-size: 12px">
              <div>资金类型: {{ formatHandel('fundType',item.fundType) }}</div>
              <div v-if="advances.channelType != 1 && (item.fundType == 1 || item.fundType == 2)">执行客户: {{item.execCustomerName}} </div>
              <template v-if="item.fundType == 1 || item.fundType == 2">
                <div style="padding-left:50px; text-indent:-50px;">项目名称: {{`【${item.projectId}】：${getValue(item.projectName)} | ${item.industryName?item.industryName : '-'}`}} </div>
                <div>账户名称: {{ item.accountName || '--' }}</div>
                <div>账户ID: {{ item.accountNo }}</div>
                <div>账户币: {{ item.rechargeMoney }}  &nbsp;&nbsp;&nbsp;&nbsp; 现金金额(元)：: {{ item.payMoney }}元</div>
                <div v-if="item.serviceId">所属服务商ID: {{ item.serviceId }} <span v-if="item.subAccountId">子账户ID: {{ item.subAccountId }}</span></div>
              </template>
              <div style="color: #333; font-size: 12px">充值状态:
                <span v-if="item.rechargeStatus == 1" style="color: #F56C6C">未充值</span>
                <span v-if="item.rechargeStatus == 3" style="color: #E6A23C">驳回</span>
                <span v-if="item.rechargeStatus == 2" style="color: #67C23A">已充值</span>
                <span v-if="item.rechargeStatus == 4" style="color: #F56C6C">退款</span>
              </div>
              <template v-if="item.rechargeStatus == 2">
                <div>媒介充值用户: {{item.mediaUserName}}</div>
                <div>媒介充值时间： {{item.mediaTime}}</div>
                <div v-if="item.mediaUrl">媒介充值图片:
                  <van-button type="info" size="mini" plain @click="showImg(item.mediaUrl)" v-if="item.mediaUrl">点击查看</van-button>
                </div>
              </template>
              <div v-if="item.remark">失败原因: {{ item.remark }}</div>
            </div>
          </div>
        </van-cell>
      </van-list>
      <van-cell style="color: #ff976a;" :title="'注：如充值结果返回的充值状态是未充值，业务员可以到已申请的页面再次操作在线充值。'" />
    </van-dialog>

    <van-dialog v-model="authIdsVisible" title="账户ID管理" width="98%" style="height:80%" class="verifyClue" :beforeClose="authIdsBeforeClose" show-cancel-button>
      <van-form ref="authIdsForm" validate-trigger="onSubmit" class="dialog-form-wrap" style="height:98%;">
        <van-button style="margin: 5px; width: 30%" round block type="primary" native-type="button" size="small" @click="handleAccountID">+添加账户ID</van-button>
        <div class="vant-table">
          <table cellspacing="0" style="width:100%" class="table">
            <tr>
              <th class="th">账户ID</th>
              <th class="th">账户币/现金(元)</th>
            </tr>
            <tr v-for="(item,index) in authIdsForm.authIdsList" :key="index + '01'" class="list-tr">
              <td>
                <div style="display: flex;align-items: center;">
                  <van-icon v-if="index != 0" name="delete-o" size="20" color="#ee0a24" @click.stop="delAuthId(index)" />
                </div>
                <van-field readonly clickable v-model="item.accountNo" @click="showPicker('accountNo',index)" label="ID" placeholder="请选择账户ID" :rules="[{ required: true }]" required />
              </td>
              <td>
                <van-field v-model="item.rechargeMoney" @blur="getPayMoney('rechargeMoney',item.rechargeMoney,index)" :disabled="!item.accountNo" label="币" placeholder="请输入账户币" type="number" :rules="[{ required: true }]" required />
                <van-field v-model="item.payMoney" @blur="getPayMoney('payMoney',item.payMoney,index)" :disabled="!item.accountNo" label="现" placeholder="请输入现金金额" type="number" :rules="[{ required: true }]" required >
                  <template slot="right-icon">￥</template>
                </van-field>
              </td>
            </tr>
            <tr>
              <td>合计</td>
              <td style="text-align: left;padding-left: 20px;">
                <div>币:{{ authIdsForm.rechargeMoney }}</div>
                <div>现:￥{{authIdsForm.payMoney}}</div>
                <!-- <span style="color: #409EFF;margin-left: 10px;">{{toChineseBig(authIdsForm.payMoney)}}</span> -->
              </td>
            </tr>
          </table>
          <div style="margin: 5px; display: flex; justify-content: right;">
            <van-button style="width: 30%" round block type="info" native-type="button" size="small" @click="addAuthId">+添加ID明细</van-button>
          </div>
        </div>
        <!-- <van-collapse v-model="activeNamesID">
          <van-collapse-item :name="index" v-for="(item,index) in authIdsForm.authIdsList" :key="index+'01'" style="border-bottom: dashed 2px #1989fa;">
            <template #title>
              <div class="list_title">
                <van-tag type="success" size="large">账户ID({{index + 1}})</van-tag>
                <div style="margin-right: 10px;">
                  <van-icon name="add-o" size="30" color="#07c160" @click.stop="addAuthId" />
                  <van-icon v-if="index != 0" name="delete-o" size="30" color="#ee0a24" @click.stop="delAuthId(index)" />
                </div>
              </div>
            </template>
            <van-field readonly clickable v-model="item.accountNo" @click="showPicker('accountNo',index)" label="账户ID" placeholder="请选择账户ID" :rules="[{ required: true }]" required>
              <template #button>
                <van-button type="primary" native-type="button" size="small" @click.stop="handleAccountID">+添加</van-button>
              </template>
            </van-field>
            <van-field v-model="item.rechargeMoney" @blur="getPayMoney('rechargeMoney',item.rechargeMoney,index)" :disabled="!item.accountNo" label="账户币" placeholder="请输入账户币" type="number" :rules="[{ required: true }]" required />
            <van-field v-model="item.payMoney" @blur="getPayMoney('payMoney',item.payMoney,index)" :disabled="!item.accountNo" label="充值金额(元)" placeholder="请输入充值金额" type="number" :rules="[{ required: true }]" required >
              <template slot="right-icon">￥</template>
            </van-field>
          </van-collapse-item>
        </van-collapse>
        <div class="money_total">
          <div class="total_title">总计</div>
          <div class="totle_divider"></div>
          <div class="item" >
            <span class="key">账户币：</span>
            <span class="value">{{ authIdsForm.rechargeMoney }}</span>
          </div>
          <div class="item" >
            <span class="key">现金金额(元)：</span>
            <span class="value">
              ￥{{authIdsForm.payMoney}}<span style="color: #409EFF;margin-left: 10px;">{{toChineseBig(authIdsForm.payMoney)}}</span>
            </span>
          </div>
        </div> -->
      </van-form>
    </van-dialog>
    <!-- 项目绑定账户ID -->
    <account-id ref="accountId"></account-id>

    <!-- 执行垫款审批中撤回弹窗 -->
    <van-image-preview v-model="revokeVisible" :images="revokeImgUrlArr"></van-image-preview>
  </div>
</template>

<script>
// import Empty from '@/components/common/Empty'
import payment from '@/api/cont/payment'
import channel from '@/api/channel/channel'
import { getUserDeptListByRole } from '@/api/system/user'
import newContract from '@/api/cont/newContract'
import DialogAdvances from '../components/DialogAdvances.vue'
import { companyList } from '@/api/admi/dept'
import { selectDeptIdByUserList, listBacklog } from '@/api/admi/user'
import { getValue } from '@/utils/util'
import { Toast, Dialog, Cascader, ImagePreview } from 'vant'
import Empty from '@/components/common/Empty'
import { mapGetters } from 'vuex'
// import store from '@/store'
import AccountId from '@/views/channel/recharge/AccountId'
import LogExamine from '@/components/LogExamine.vue'
export default {
  components: {
    AccountId,
    DialogAdvances,
    Empty,
    [Toast.name]: Toast,
    [Dialog.Component.name]: Dialog.Component,
    [ImagePreview.Component.name]: ImagePreview.Component,
    vanCascader: Cascader,
    LogExamine
  },
  computed: {
    ...mapGetters({
      userinfo: 'userinfo'
    })
  },
  data() {
    return {
      active: 0,
      advancesArr: ['垫款草稿', '审核驳回', '部门审核中', '执行垫款审批中', '业务员确认中', '媒介确认中', '媒介已确认'],
      advancesImg: require('../../../assets/images/desktop/advances.png'),
      advancesFormShow: false,
      bmshVisible: false,
      bmshForm: { contAdvancesId: '', checkStatus: '2', checkReason: '' },
      ywyVisible: false,
      ywyForm: { operationDeptId: null, operationDeptName: null, operationUserId: '', operationUserName: '', checkStatus: '4', checkReason: '' },
      yyqrVisible: false,
      yyqrForm: { contAdvancesId: '', checkStatus: '5', checkReason: '' },
      value1: '',
      deptTreeList: [], // 部门树选项
      tree: {
        type: '',
        title: '',
        typeTree: false,
        treeList: [],
        fieldNames: {

        }
      },
      deptUserList: [], // 我方签约人列表集合
      picker: {
        visible: false,
        title: '',
        columns: [],
        formKey: '',
        loading: false
      },
      cwdkVisible: false,
      cwdkForm: { contAdvancesId: '', checkStatus: '6', contPayCompanyName: '', contPayCompanyId: null, bankId: '', payBankAccountNo: '', checkReason: '' },
      companyList: [],
      payBankList: [],
      advances: {},
      options: {
        // 业务类型树选项
        businessTypeOptions: this.$store.state.dictOptions.businessTypeTree || [],
        payTypeOptions: [],
        frameTypeOptions: [],
        custSourceOptions: [],
        advancesTypeOptions: [],
        creditCycleTypeOptions: [],
        fundTypeOptions: [],
        tenFundTypeOptions: []
      },
      amountTotal: '',
      amountTotalAdd: '',
      operationLogList: [],
      isJudge: false, // 是否逾期
      overdueList: [],
      returnList: [],
      imageShow: false,
      imageArr: [],

      // 垫款充值
      execCustomerId: null,
      execCustomerName: null,
      rechargeVisible: false,
      rechargeForm: {
        contractId: null,
        contNewIncomeDetailId: null,
        flowList: [],
        payMoney: null,
        rechargeMoney: null
      },
      activeNames: [0],
      index: null,
      activeNamesID: [0],
      authIdsVisible: false,
      authIdsForm: {
        payMoney: 0,
        rechargeMoney: 0,
        authIdsList: [{
          accountNo: null,
          payMoney: null,
          rechargeMoney: null
        }]
      },
      flowIndex: null,
      authIdQuery: {
        pageNum: 1,
        pageSize: 100,
        projectId: null,
        accountId: null
      },
      accountNoList: [],

      execCustomerList: [],
      projectList: [],

      // 指定媒介
      designatedVisible: false,
      designatedForm: {
        dataType: null,
        contNewIncomeDetailId: null,
        mediaUserId: null,
        mediaUserName: null
      },

      serviceIdList: [],
      subAccountIdList: [],
      accountType: null,
      onlineVisible: false,
      makeCardDDataListCopy: [],
      activeNamesOnline: [0],
      resultVisible: false,
      resultList: [],

      revokeVisible: false,
      revokeImgUrlArr: [require('../../../assets/images/module/advance01.png'), require('../../../assets/images/module/advance02.png'),
        require('../../../assets/images/module/advance03.png'), require('../../../assets/images/module/advance04.png')
      ]
    }
  },
  created() {
    // store.dispatch('user/GetDbCount')
    this.getOptions()
    this.getDicts('credit_cycle_type').then(res => {
      this.options.creditCycleTypeOptions = res.data
    })
  },
  mounted() {
    if (JSON.parse(sessionStorage.getItem('advancesQuery'))) {
      sessionStorage.setItem('advancesSearch', true)
    }
    this.init()
  },
  methods: {
    async init() {
      document.title = '垫款详情'
      await this.getAdvances(this.$route.query.id)
      // await this.getLogList()
      await this.getJudge()
      await this.getReturnList()
      await payment.selectByDeptIdMoney({}).then(res => {
        this.amountTotal = res.data.money
      })
      await payment.selectByDeptIdMoneyAdd({}).then(res => {
        this.amountTotalAdd = res.data.money
      })
    },
    async getAdvances(val) {
      const res = await payment.getAdvances(val)
      if (res.code === 200) {
        this.advances = res.data
        this.advances.payMoney1 = res.data.payMoney
      }
      console.log(this.advances.payMoney)
    },
    // 获取操作记录
    async getLogList() {
      const params = {
        contractId: this.$route.query.id,
        bigType: 3
      }
      newContract.listContractLog(params).then(response => {
        this.operationLogList = response.rows
      })
    },
    tabClick(name, title) {
      if (name === 1) {
        this.getLogList()
      }
    },
    getReturnList() {
      payment.listDetailed({ contAdvancesId: this.advances.contAdvancesId }).then(res => {
        if (res.code == 200) {
          this.returnList = res.rows
        }
      })
    },
    getJudge() {
      payment.judgeAdvances(this.advances.contractId).then(res => {
        this.isJudge = res.data != 0
        if (this.isJudge) {
          this.getOverdueList()
        }
      })
    },
    // 逾期
    getOverdueList() {
      payment.listAdvances({ isExpectDate: 1, contractId: this.advances.contractId, checkStatus: 6 }).then(response => {
        this.overdueList = response.rows
      })
    },
    showImg(val) {
      this.imageArr = []
      this.imageArr.push(this.advances[val])
      this.imageShow = true
    },
    // 修改
    handleUpdate() {
      this.advancesFormShow = true
    },
    handleAdvancesCancel() {
      this.advancesFormShow = false
    },
    addAdvancesBeforeClose() {
      this.advancesFormShow = false
      this.init()
    },
    // 撤回
    handleRevoke() {
      if (this.advances.checkStatus === 2) {
        Dialog.confirm({
          message: '是否确认撤回此条垫款申请'
        })
          .then(() => {
            payment.revokeAdvances({ contAdvancesId: this.advances.contAdvancesId }).then(res => {
              if (res.code == 200) {
                Toast.success('撤回成功!')
                setTimeout(() => {
                  this.$router.go(-1)
                }, 500)
              }
            })
          })
          .catch(() => {
            // on cancel
          })
      } else if (this.advances.checkStatus === 3) {
        this.revokeVisible = true
      }
    },
    // 删除
    handleDelete() {
      Dialog.confirm({
        message: '是否确认删除此条垫款数据'
      })
        .then(() => {
          payment.deleteAdvances(this.advances.contAdvancesId).then(res => {
            if (res.code == 200) {
              Toast.success('成功删除!')
              setTimeout(() => {
                this.$router.go(-1)
              }, 500)
            }
          })
        })
        .catch(() => {
        // on cancel
        })
    },
    // 提交草稿
    async handleCg() {
      const that = this
      const params = {
        contAdvancesId: this.advances.contAdvancesId
        // contAdvancesId: this.advances.contAdvancesId,
        // checkStatus: 0,
        // submitType: 1
      }
      await payment.isAdvancesApproval(this.advances).then(isRes => {
        if (isRes.code === 200) {
          if (isRes.data) {
            Dialog.confirm({
              title: '警告',
              message: '提示：该合同或执行客户已提交垫款申请在审批中，是否继续提交申请？'
            })
              .then(() => {
                payment.submitAdvances(params).then(res => {
                  if (res.code == 200) {
                    Toast.success('提交成功!')
                    setTimeout(() => {
                      that.$router.go(-1)
                    }, 500)
                  } else {
                    Toast.fail(res.msg)
                    setTimeout(() => {
                      that.advancesFormShow = true
                    }, 500)
                  }
                })
              })
          } else {
            Dialog.confirm({
              message: '是否确认提交垫款申请'
            })
              .then(() => {
                payment.submitAdvances(params).then(res => {
                  if (res.code == 200) {
                    Toast.success('提交成功!')
                    setTimeout(() => {
                      that.$router.go(-1)
                    }, 500)
                  } else {
                    Toast.fail(res.msg)
                    setTimeout(() => {
                      that.advancesFormShow = true
                    }, 500)
                  }
                })
              })
              .catch(() => {
                // on cancel
              })
          }
        }
      })
    },
    handleNext() {
      const that = this
      Dialog.confirm({
        message: '是否确认当前垫款申请'
      })
        .then(() => {
          const params = {
            contAdvancesId: this.advances.contAdvancesId,
            checkStatus: 2
          }
          payment.updateAdvances(params).then(res => {
            if (res.code == 200) {
              Toast.success('确认成功!')
              setTimeout(() => {
                const query = {
                  backlogType: 4,
                  childType: 2,
                  userId: this.userinfo.userId,
                  checkStatus: 0
                }
                listBacklog(query).then(res => {
                  if (res.code == 200) {
                    if (res.rows.length > 0) {
                      this.getAdvances(res.rows[0].bussId)
                    } else {
                      Toast.fail('暂无需要部门审核的数据')
                      this.getAdvances(that.advances.contAdvancesId)
                    }
                  }
                })
              }, 500)
            }
          })
        })
        .catch(() => {
        // on cancel
        })
    },
    // 部门审核
    handleBmsh() {
      this.bmshVisible = true
    },
    async bmshBeforeClose(type, done) {
      if (type === 'confirm') {
        try {
          await this.$refs.bmshForm.validate()
          this.bmshForm.contAdvancesId = this.advances.contAdvancesId
          payment.updateAdvances(this.bmshForm)
            .then((res) => {
              if (res.code == 200) {
                Toast.success('审核成功')
                this.getAdvances(this.advances.contAdvancesId)
                setTimeout(() => {
                  // this.$router.go(-1)
                  this.$router.push({
                    path: '/daiban',
                    query: { type: 3 }
                  })
                }, 500)
              } else {
                Toast.fail(res.msg)
              }
            }).catch(() => {})
          done()
        } catch (err) {
          return done(false)
        }
        return done(false)
      } else {
        done()
        this.bmshVisible = false
      }
    },
    handleYy() {
      this.yyqrVisible = true
    },
    // 媒介
    async yyqrBeforeClose(type, done) {
      if (type === 'confirm') {
        try {
          await this.$refs.yyqrForm.validate()
          this.yyqrForm.contAdvancesId = this.advances.contAdvancesId
          await payment.updateAdvances(this.yyqrForm)
            .then((res) => {
              if (res.code == 200) {
                Toast.success('确认成功')
                this.getAdvances(this.advances.contAdvancesId)
                setTimeout(() => {
                  // this.$router.go(-1)
                  this.$router.push({
                    path: '/daiban',
                    query: { type: 3 }
                  })
                }, 500)
              } else {
                Toast.fail(res.msg)
              }
            }).catch(() => {})
          done()
        } catch (err) {
          return done(false)
        }
        return done(false)
      } else {
        done()
        this.yyqrVisible = false
      }
    },
    // 业务员确认
    handleYwy() {
      this.ywyVisible = true
    },
    // 打开联级选择框
    async showCascader(val) {
      if (val === 'dept') {
        if (this.deptTreeList.length == 0) {
          await payment.listDept().then((response) => {
            this.deptTreeList = response.data
          })
        }
        this.tree = {
          type: val,
          title: '请选择部门',
          typeTree: true,
          treeList: this.deptTreeList,
          fieldNames: {
            text: 'label', value: 'id', children: 'children'
          }
        }
      }
    },
    treeChange(obj) {
      if (this.tree.type === 'dept') {
        this.ywyForm.operationDeptId = obj.value
        this.ywyForm.operationDeptName = obj.selectedOptions.map((option) => option.label).join('/')
      }
    },
    async getContTencentAccountTokenList(accountType) {
      await payment.getContTencentAccountTokenList({ accountType }).then(res => {
        if (res.code === 200) {
          this.serviceIdList = res.data
        }
      })
      await payment.getSubAccountTokenList({ accountType }).then(res => {
        if (res.code === 200) {
          this.subAccountIdList = res.data
        }
      })
      if (accountType === 1) {
        await this.getDicts('finance_account_type').then(res => {
          this.options.tenFundTypeOptions = res.data
        })
      }
    },
    async onSearch() {
      await this.getAuthIds(this.rechargeForm.flowList[this.flowIndex].projectId)
      // this.accountNoList = this.accountNoList.filter(item => {
      //   return (item.accountId.toString()).indexOf(this.searchValue) > -1
      // })
      this.picker.columns = this.accountNoList.map((ele) => ele.accountId)
    },
    async showPicker(type, index) {
      if (index || index == 0) {
        this.index = index
      } else {
        this.index = null
      }
      this.picker.loading = true
      this.picker.columns = []
      this.picker.formKey = type
      const optionItem = type + 'Options'
      if (type === 'userName') {
        // 选择人员
        selectDeptIdByUserList(this.ywyForm.operationDeptId).then(response => {
          this.deptUserList = response.data
          this.picker.columns = this.deptUserList.map(item => item.nickName)
          this.picker.loading = false
        })
      } else if (type === 'company') {
        // 获取公司信息
        if (this.companyList.length == 0) {
          await companyList().then((response) => {
            this.companyList = response.rows
          })
        }
        this.picker.columns = this.companyList.map((ele) => ele.companyName)
        this.picker.loading = false
      } else if (type === 'incomeBank') {
        await payment.listPayBank({ companyId: this.cwdkForm.contPayCompanyId }).then(res => {
          if (res.code === 200) {
            this.payBankList = res.rows
          }
        })
        this.payBankList.forEach((ele) => {
          ele.incomeBankName = `${ele.bankName}(${ele.accountNum})`
        })
        this.picker.columns = this.payBankList.map((ele) => ele.incomeBankName)
        this.picker.loading = false
      } else if (type === 'user') {
        await getUserDeptListByRole(this.advances.deptId).then(res => {
          if (res.code == 200) {
            this.userList = res.data
          }
        })
        this.picker.columns = this.userList.map((ele) => ele.nickName)
        this.picker.loading = false
      } else if (type === 'accountNo') {
        this.picker.columns = this.accountNoList.map((ele) => ele.accountId)
        this.picker.loading = false
      } else if (type === 'execCustomers') {
        this.picker.columns = this.execCustomerList.map((ele) => ele.execCustomerName)
        this.picker.loading = false
      } else if (type === 'projects') {
        this.picker.columns = this.projectList.map((ele) => `【${ele.percentage}%/${ele.calculationMethodStr}】${getValue(ele.projectName)} | ${ele.industryName ? ele.industryName : '-'}`)
        this.picker.loading = false
      } else if (type === 'serviceId') {
        this.picker.columns = this.serviceIdList.map((ele) => ele.accountId + '  ' + ele.remark)
        this.picker.loading = false
      } else if (type === 'subAccountId') {
        this.picker.columns = this.subAccountIdList.map((ele) => ele.accountId + '  ' + ele.remark)
        this.picker.loading = false
      } else {
        this.picker.columns = this.options[optionItem].map((ele) => ele.dictLabel)
        this.picker.loading = false
      }
      this.picker.visible = true
    },
    async pickerConfirm(value, key) {
      const optionItem = this.picker.formKey + 'Options'
      console.log('key:' + key)
      const name = this.picker.formKey + 'Name'
      if (this.index || this.index == 0) {
        if (this.picker.formKey === 'accountNo') {
          if (this.authIdsForm.authIdsList.some(abc => { return abc.accountNo == this.accountNoList[key].accountId })) {
            Toast.fail('不能添加重复的账户ID')
            return
          }
          // this.accountNoList = this.accountNoList.filter(item => {
          //   return (item.accountId.toString()).indexOf(this.searchValue) > -1
          // })
          this.authIdsForm.authIdsList[this.index].accountNo = this.accountNoList[key].accountId
        } else if (this.picker.formKey === 'execCustomers') {
          this.rechargeForm.flowList[this.index].execCustomerId = this.execCustomerList[key].execCustomerId
          this.rechargeForm.flowList[this.index].execCustomerName = this.execCustomerList[key].execCustomerName
          this.execCustomerId = this.execCustomerList[key].execCustomerId
          this.execCustomerName = this.execCustomerList[key].execCustomerName
          this.getProjectList(2, this.execCustomerList[key].execCustomerId)
        } else if (this.picker.formKey === 'projects') {
          this.rechargeForm.flowList[this.index].projectId = this.projectList[key].projectId
          this.rechargeForm.flowList[this.index].projectName = this.projectList[key].projectName
        } else if (this.picker.formKey === 'serviceId') {
          this.rechargeForm.execAccountList[this.index].serviceName = this.serviceIdList[key].accountId + '  ' + this.serviceIdList[key].remark
          this.rechargeForm.execAccountList[this.index].serviceId = this.serviceIdList[key].accountId
        } else if (this.picker.formKey === 'subAccountId') {
          this.rechargeForm.execAccountList[this.index].subAccountName = this.subAccountIdList[key].accountId + '  ' + this.subAccountIdList[key].remark
          this.rechargeForm.execAccountList[this.index].subAccountId = this.subAccountIdList[key].accountId
        } else if (this.picker.formKey === 'tenFundType') {
          this.rechargeForm.execAccountList[this.index].tenFundType = this.options[optionItem][key].dictValue
          this.rechargeForm.execAccountList[this.index].tenFundTypeName = this.options[optionItem][key].dictLabel
        } else {
          this.rechargeForm.flowList[this.index][this.picker.formKey] = this.options[optionItem][key].dictValue
          this.rechargeForm.flowList[this.index][name] = this.options[optionItem][key].dictLabel
        }
      } else {
        if (this.picker.formKey === 'user') {
          this.designatedForm.mediaUserId = this.userList[key].userId
          this.designatedForm.mediaUserName = this.userList[key].nickName
        } else if (this.picker.formKey === 'userName') {
          this.ywyForm.operationUserName = this.deptUserList[key].nickName
          this.ywyForm.operationUserId = this.deptUserList[key].userId
        } else if (this.picker.formKey === 'company') {
          this.cwdkForm.contPayCompanyName = this.companyList[key].companyName
          this.cwdkForm.contPayCompanyId = this.companyList[key].companyId
        } else if (this.picker.formKey === 'incomeBank') {
          this.cwdkForm.payBankAccountName = this.payBankList[key].incomeBankName
          this.cwdkForm.payBankAccountNo = this.payBankList[key].bankAccountId
          this.cwdkForm.bankId = this.payBankList[key].accountNum
        } else {
          this.form[this.picker.formKey] = this.options[optionItem][key].dictValue
          this.form[name] = this.options[optionItem][key].dictLabel
        }
      }
      this.picker.visible = false
    },
    pickerCancel() {
      this.picker.visible = false
    },
    async ywyBeforeClose(type, done) {
      if (type === 'confirm') {
        try {
          await this.$refs.ywyForm.validate()
          this.ywyForm.contAdvancesId = this.advances.contAdvancesId
          await payment.updateAdvances(this.ywyForm)
            .then((res) => {
              if (res.code == 200) {
                Toast.success('确认成功')
                this.getAdvances(this.advances.contAdvancesId)
                setTimeout(() => {
                  // this.$router.go(-1)
                  this.$router.push({
                    path: '/daiban',
                    query: { type: 3 }
                  })
                }, 500)
              } else {
                Toast.fail(res.msg)
              }
            }).catch(() => {})
          done()
        } catch (err) {
          return done(false)
        }
        return done(false)
      } else {
        done()
        this.ywyVisible = false
      }
    },
    // 媒介确认
    // handleYy() {
    //   Dialog.confirm({
    //     message: '是否确认当前垫款申请'
    //   })
    //     .then(() => {
    //       const params = {
    //         contAdvancesId: this.advances.contAdvancesId,
    //         checkStatus: 5
    //       }
    //       payment.updateAdvances(params).then(res => {
    //         if (res.code == 200) {
    //           Toast.success('确认成功!')
    //           setTimeout(() => {
    //             this.$router.go(-1)
    //           }, 500)
    //         }
    //       })
    //     })
    //     .catch(() => {
    //     // on cancel
    //     })
    // },
    // 财务打款确认
    handleCwdk() {
      this.cwdkVisible = true
    },
    async cwdkBeforeClose(type, done) {
      if (type === 'confirm') {
        try {
          await this.$refs.cwdkForm.validate()
          this.cwdkForm.contAdvancesId = this.advances.contAdvancesId
          await payment.updateAdvances(this.cwdkForm)
            .then(() => {
              Toast.success('确认成功')
              setTimeout(() => {
                this.$router.go(-1)
              }, 500)
            }).catch(() => {})
          done()
        } catch (err) {
          return done(false)
        }
        return done(false)
      } else {
        done()
        this.cwdkVisible = false
      }
    },
    // 跳转合同详情
    handleDetails() {
      this.$router.push({
        path: '/cont/approve/detail',
        query: { id: this.advances.contractId }
      })
    },
    formatHandel(type, value) {
      const options = type + 'Options'
      if (value || value == 0) {
        return this.selectDictLabel(this.options[options], value)
      } else {
        return ''
      }
    },
    pickerChange() {

    },
    async getOptions() {
      // 框架类型
      await this.getDicts('frame_type').then(res => {
        this.options.frameTypeOptions = res.data
      })
      // 客户来源类型
      await this.getDicts('cust_source').then(res => {
        this.options.custSourceOptions = res.data
      })
      // 垫款方式
      await this.getDicts('pay_type').then(res => {
        this.options.payTypeOptions = res.data
      })
      // 垫款类型
      await this.getDicts('advances_type').then(res => {
        this.options.advancesTypeOptions = res.data
      })

      await this.getDicts('money_type_advances').then(res => {
        this.options.fundTypeOptions = this.setDictToInt(res)
      })
    },

    async handleRecharge() {
      // if (this.advances.custSource == 2) {
      //   await payment.listExecutive({ contractId: this.advances.contractId }).then(res => {
      //     if (res.code == 200) {
      //       this.execCustomerList = res.rows
      //     }
      //   })
      //   this.projectList = []
      // }
      this.rechargeForm = {
        dataType: 3,
        contractId: null,
        contNewIncomeDetailId: null,
        flowList: [],
        payMoney: null,
        rechargeMoney: null
      }
      this.rechargeForm.flowList = []
      if (this.advances.custSource == 2) {
        this.execCustomerId = this.advances.execCustomerId
        this.execCustomerName = this.advances.execCustomerName
        await this.getProjectList(2, this.advances.execCustomerId)
      } else {
        this.execCustomerId = null
        this.execCustomerName = null
        await this.getProjectList(1, this.advances.contractId)
      }
      this.rechargeVisible = true
    },
    // 获取项目名称列表
    async getProjectList(type, id) {
      await newContract.listProjectPercentage({ bussType: type, bussId: id }).then(res => {
        if (res.code == 200) {
          this.projectList = res.data
        }
      })
    },
    async addExecutive() {
      const obj = {}
      // const contInfo = await newContract.getContract(this.advances.contractId)
      // if (contInfo.data.businessTypeName.indexOf('效果运营类') > -1) {
      //   if (contInfo.data.operationMode == 2) {
      //     obj.fundType = 1
      //     obj.fundTypeName = '代运营充值'
      //   } else {
      //     obj.fundType = 2
      //     obj.fundTypeName = '媒介充值'
      //   }
      // } else if (contInfo.data.businessTypeName.indexOf('数字媒介类') > -1) {
      //   obj.fundType = 2
      //   obj.fundTypeName = '媒介充值'
      // }
      if (this.advances.custSource == 2) {
        obj.execCustomerId = this.execCustomerId
        obj.execCustomerName = this.execCustomerName
        await this.getProjectList(2, this.execCustomerId)
      } else {
        await this.getProjectList(1, this.advances.contractId)
      }
      if (this.projectList.length == 1) {
        obj.projectId = this.projectList[0].projectId
        obj.projectName = this.projectList[0].projectName
        if (obj.projectName.indexOf('代运营') > -1) {
          obj.fundType = 1
          obj.fundTypeName = '代运营充值'
        } else {
          obj.fundType = 2
          obj.fundTypeName = '媒介充值'
        }
      }
      this.rechargeForm.flowList.push({
        fundType: obj.fundType || null,
        fundTypeName: obj.fundTypeName || null,
        execCustomerId: obj.execCustomerId || null,
        execCustomerName: obj.execCustomerName || null,
        projectId: obj.projectId || null,
        projectName: obj.projectName || null,
        authIds: null,
        rechargeMoney: null,
        payMoney: null,
        authIdsList: [{
          accountNo: null,
          payMoney: null,
          rechargeMoney: null
        }]
      })
      // if (this.advances.custSource == 2) {
      //   await this.getProjectList(2, this.execCustomerId)
      // }
      const res = this.activeNames.some(item => {
        return this.rechargeForm.flowList.length - 1 === item
      })
      if (res === false) {
        this.activeNames.push(this.rechargeForm.flowList.length - 1)
      }
    },
    delExecutive(index) {
      if (this.rechargeForm.flowList.length > 0) {
        this.rechargeForm.flowList.splice(index, 1)
        this.rechargeForm.rechargeMoney = this.rechargeForm.flowList.reduce((total, item) => total + Number(item.rechargeMoney), 0)
        this.rechargeForm.payMoney = this.rechargeForm.flowList.reduce((total, item) => total + Number(item.payMoney), 0)
      }
    },
    async selectAuthIds(index) {
      if (!this.rechargeForm.flowList[index].projectId) {
        Toast.fail('请先选择项目名称')
        return false
      }
      this.authIdsForm.accountMoney = 0
      this.authIdsForm.rechargeMoney = 0
      this.authIdsForm.authIdsList = [{
        accountNo: null,
        payMoney: null,
        rechargeMoney: null
      }]
      this.authIdQuery.projectId = this.rechargeForm.flowList[index].projectId
      await this.getAuthIds(this.rechargeForm.flowList[index].projectId)
      this.flowIndex = index
      if (this.rechargeForm.flowList.length > 0 && this.rechargeForm.flowList[index].authIdsList) {
        this.authIdsForm.authIdsList = this.rechargeForm.flowList[index].authIdsList
      }
      this.authIdsForm.payMoney = this.authIdsForm.authIdsList.reduce((total, item) => total + Number(item.payMoney), 0)
      this.authIdsForm.rechargeMoney = this.authIdsForm.authIdsList.reduce((total, item) => total + Number(item.rechargeMoney), 0)
      this.authIdsVisible = true
    },
    async getAuthIds(projectId) {
      await payment.listByProjectId(this.authIdQuery).then(res => {
        if (res.code == 200) {
          this.accountNoList = res.data
        } else {
          Toast.fail(res.msg)
        }
      })
    },
    handleAccountID() {
      const params = {
        contractId: this.advances.contractId,
        projectId: this.rechargeForm.flowList[this.flowIndex].projectId,
        projectName: this.rechargeForm.flowList[this.flowIndex].projectName,
        endDateStr: this.advances.endTime,
        execCustomerId: this.rechargeForm.flowList[this.flowIndex].execCustomerId || null,
        execCustomerName: this.rechargeForm.flowList[this.flowIndex].execCustomerName || null,
        dataType: 2
      }
      this.$refs.accountId.handleAccountID(params, 'direct')
    },
    addAuthId() {
      this.authIdsForm.authIdsList.push({
        accountNo: null,
        payMoney: null,
        rechargeMoney: null,
        fundType: this.rechargeForm.flowList[this.flowIndex].fundType,
        money: this.advances.rechargeRemainMoney
      })
      const res = this.activeNamesID.some(item => {
        return this.authIdsForm.authIdsList.length - 1 === item
      })
      if (res === false) {
        this.activeNamesID.push(this.authIdsForm.authIdsList.length - 1)
      }
    },
    delAuthId(index) {
      if (this.authIdsForm.authIdsList.length > 0) {
        this.authIdsForm.authIdsList.splice(index, 1)
      }
      this.authIdsForm.payMoney = this.authIdsForm.authIdsList.reduce((total, item) => total + Number(item.payMoney), 0)
      this.authIdsForm.rechargeMoney = this.authIdsForm.authIdsList.reduce((total, item) => total + Number(item.rechargeMoney), 0)
    },
    async getPayMoney(type, val, index) {
      const params = {
        payMoney: null,
        rechargeMoney: null,
        fundType: this.rechargeForm.flowList[this.flowIndex].fundType,
        projectId: this.rechargeForm.flowList[this.flowIndex].projectId,
        contractId: this.advances.contractId
      }
      if (type == 'payMoney') {
        params.payMoney = val
        params.rechargeMoney = null
        await channel.getPayMoney(params).then(res => {
          if (res.code == 200) {
            this.authIdsForm.authIdsList[index].rechargeMoney = res.data
          }
        })
      } else if (type == 'rechargeMoney') {
        params.payMoney = null
        params.rechargeMoney = val
        await channel.getPayMoney(params).then(res => {
          if (res.code == 200) {
            this.authIdsForm.authIdsList[index].payMoney = res.data
          }
        })
      }
      this.authIdsForm.payMoney = this.authIdsForm.authIdsList.reduce((total, item) => total + Number(item.payMoney), 0)
      this.authIdsForm.rechargeMoney = this.authIdsForm.authIdsList.reduce((total, item) => total + Number(item.rechargeMoney), 0)
    },
    async authIdsBeforeClose(type, done) {
      if (type === 'confirm') {
        try {
          await this.$refs.authIdsForm.validate()
          this.authIdsForm.authIdsList[0].fundType = this.rechargeForm.flowList[this.flowIndex].fundType
          this.authIdsForm.authIdsList[0].money = this.advances.rechargeRemainMoney
          await payment.getExecBatch(this.authIdsForm.authIdsList).then(res => {
            if (res.code == 200) {
              this.rechargeForm.flowList[this.flowIndex].authIds = res.data.authIds
              this.rechargeForm.flowList[this.flowIndex].rechargeMoney = res.data.rechargeMoney
              this.rechargeForm.flowList[this.flowIndex].payMoney = res.data.payMoney
              this.rechargeForm.payMoney = this.rechargeForm.flowList.reduce((total, item) => total + Number(item.payMoney), 0)
              this.rechargeForm.rechargeMoney = this.rechargeForm.flowList.reduce((total, item) => total + Number(item.rechargeMoney), 0)
              this.authIdsVisible = false
              this.rechargeForm.flowList[this.flowIndex].authIdsList = this.authIdsForm.authIdsList
              done()
            } else {
              Toast.fail(res.msg)
            }
          })
        } catch (err) {
          return done(false)
        }
        return done(false)
      } else {
        return done()
      }
    },
    getAllPayMoney(index) {
      if (index == this.rechargeForm.flowList.length - 1) {
        this.rechargeForm.payMoney = this.rechargeForm.flowList.reduce((total, item) => total + Number(item.payMoney), 0)
      }
    },
    // 在线充值
    async saveRechargeOnline() {
      if (this.rechargeForm.flowList.length === 0) {
        Toast.fail('请先添加充值明细')
        return
      }
      await this.$refs.rechargeForm.validate()
      this.rechargeForm.execAccountList = []
      this.rechargeForm.flowList.forEach(item => {
        Array.prototype.push.apply(this.rechargeForm.execAccountList, item.authIdsList)
      })
      await payment.listGroupAccountId({ accountId: this.rechargeForm.execAccountList[0].accountNo }).then(res => {
        if (res.code === 200) {
          this.getContTencentAccountTokenList(res.data.rows[0].accountType)
          this.accountType = res.data.rows[0].accountType
        }
      })
      this.rechargeForm.execAccountList.forEach(item => {
        item.mediaRechargeType = 1
        if (this.accountType === 1) {
          item.tenFundType = 'FUND_TYPE_CASH'
          item.tenFundTypeName = '现金账户'
        }
      })
      const res = this.activeNamesOnline.some(item => {
        return this.rechargeForm.execAccountList.length - 1 === item
      })
      if (res === false) {
        this.activeNamesOnline.push(this.rechargeForm.execAccountList.length - 1)
      }
      this.onlineVisible = true
    },
    setType() {
      this.$forceUpdate()
    },
    saveOnline() {
      this.rechargeForm.onLineType = 2
      this.rechargeForm.contractId = this.advances.contractId
      this.rechargeForm.bussId = this.advances.contAdvancesId
      this.rechargeForm.companyName = this.advances.custName
      this.rechargeForm.dataType = 3
      payment.addFlowNew(this.rechargeForm).then(res => {
        if (res.code == 200) {
          if (res.data) {
            Toast.success('充值申请成功')
            this.resultList = res.data
            setTimeout(async() => {
              // await this.getRechargeInfo()
              await this.getAdvances(this.$route.query.id)
              this.onlineVisible = false
              this.rechargeVisible = false
              this.resultVisible = true
            }, 500)
          }
        } else {
          Toast.fail(res.msg)
        }
      })
    },
    // 媒介充值申请
    async saveRecharge() {
      if (this.rechargeForm.flowList.length === 0) {
        Toast.fail('请先添加充值明细')
        return
      }
      await this.$refs.rechargeForm.validate()
      this.rechargeForm.contractId = this.advances.contractId
      this.rechargeForm.bussId = this.advances.contAdvancesId
      this.rechargeForm.companyName = this.advances.custName
      this.rechargeForm.dataType = 3
      payment.addFlowNew(this.rechargeForm).then(res => {
        if (res.code == 200) {
          if (res.data.mediaUserName) {
            // Toast.success('充值申请成功,当前媒介排班人员为：' + res.data.mediaUserName)
            Dialog.alert({
              message: '充值申请成功,当前媒介排班人员为：' + res.data.mediaUserName
            }).then(() => {
              // on close
            })
            setTimeout(async() => {
              // await this.getRechargeInfo()
              await this.getAdvances(this.$route.query.id)
              this.rechargeVisible = false
            }, 1500)
          } else {
            this.advances.advancesRechargeId = res.data.advancesRechargeId
            this.advances.deptId = res.data.mediaDeptId
            Toast.fail('当前时段内未查询到排班人员，请指定媒介人员进行充值')
            setTimeout(async() => {
              // await this.getRechargeInfo()
              // await this.getAdvances(this.$route.query.id)
              this.rechargeVisible = false
              this.designatedMedia()
            }, 1500)
          }
        } else {
          Toast.fail(res.msg)
        }
      })
    },
    // 指定媒介人员
    designatedMedia() {
      this.designatedVisible = true
    },
    async saveDesignated(type, done) {
      if (type === 'confirm') {
        try {
          await this.$refs.designatedForm.validate()
          this.designatedForm.contNewIncomeDetailId = this.advances.advancesRechargeId
          this.designatedForm.dataType = 3
          payment.designatedMedia(this.designatedForm).then(res => {
            if (res.code == 200) {
              Toast.success('指定媒介人员成功')
              setTimeout(async() => {
                this.designatedVisible = false
                // await this.getRechargeInfo()
                await this.getAdvances(this.$route.query.id)
                done()
              }, 500)
            } else {
              Toast.fail(res.msg)
            }
          })
        } catch (err) {
          return done(false)
        }
        return done(false)
      } else {
        return done()
      }
    }
  }
}
</script>
<style lang="less" scoped>
@import url("@/style/index.less");
/* 跟进记录 */
/deep/.van-tabs__line {
  position: absolute;
  bottom: 0.4rem;
  left: 0;
  z-index: 1;
  width: 1rem;
  height: 0.08rem;
  background-color: #bbb;
  border-radius: 0.08rem;
  top:1rem;
}
/deep/.van-tab__text{
  font-weight: bold;
}
.cont-tab{
  overflow-y: hidden;
  // .pb(120);
}
// .concat-list{
//     // height: auto;
//     overflow: scroll;
// }

.editVisit{
    min-height: 9rem;
    height: 50%;
    top: 46%;
    .formSty{
      height: 100%; overflow: scroll; margin: 10px 5px;
    }
}
.editVisit /deep/.van-dialog__content {
  height: 70%;
  .van-field--error .van-field__control{
    font-size: 0.38rem;
  }
  .van-field__control{font-size: 0.38rem;}
  .van-cell__value {
    min-width: 67%; // 可根据自己需求设定值
    text-align: left;
  }
}
// .editVisit /deep/.van-dialog__content {
//   height: 70%;
// }
.container{
  .card{
    min-height: 200px;
    .tag_box{
      margin-top: 15px;
      line-height: 60px;
      .van-tag{
        margin-left: 12px;
        line-height: 40px;
      }
    }
  }
  .tab_box{
    background-color: #fff;
    margin: 20px 0;
    padding: 40px;
    border-radius: 10px;
    display: flex;
    justify-content: space-between;
    .tab_div{
      display: flex;
      align-items: center;
      color: #333;
      font-size: 30px;
      img{
        width: 50px;
        height: 50px;
        margin-right: 5px;
      }
      span{
        color: #1989fa;
      }
    }
  }
}
.modify_img{
  width: 66px;
  height: 66px;
  margin-left:auto;
}
/deep/.van-list{
  padding: 0;
}

/deep/.van-dialog__confirm{
  color: #ee0a24;
  border-top: 0.01333rem solid #ccc;
}
.verifyClue /deep/.van-dialog__content {
  height: 80%;
}
.verifyClue /deep/.van-dialog__header {
  background-color: #d4d4d4;
}
.media /deep/.van-dialog__content {
  height: 65%;
}
.van-cell__value {
  min-width: 67%; // 可根据自己需求设定值
  text-align: left;
}
/deep/.van-list{
  padding: 0;
}

.tag_button{
  line-height: 50px;
  margin-left: 20px;
  width: 100px;
  justify-content: center;
}

/deep/ .van-collapse-item__title{
  border-bottom: dashed 5px #1989fa;
}
.list_title{
  display: flex;
  align-items: center;
  justify-content: space-between;
  .van-icon{
    margin: 0 16px;
  }
}
.money_total{
  width: 95%;
  margin: 20px auto;
  background-color: #C6E2FF;
  border-radius: 10px;
  padding: 30px 10px 20px;
  font-size: 32px;
  .totle_divider{
    width: 98%;
    height: 4px;
    margin: 0 auto;
    background-color: #fff;
  }
  .total_title{
    padding-bottom: 10px;
    color: #ee0a24;
    text-align: center;
    letter-spacing: 30px;
    font-weight: bold;
  }
  .item{
    margin: 20px;
    font-size: 28px;
    .key{
      color: #0000FF;
    }
    .value{
      line-height: 42px;
    }
  }
}
.authId_topBtn{
  width: 30%;
  margin: 0px auto 20px;
}

/deep/ .van-divider{
  margin: 10px 0;
}

.editClue /deep/.van-dialog__content {
  height: 82%;
}
.editClue /deep/.van-dialog__footer{
  display: none;
}
.footer{
  display: flex;
  margin-top: -10px;
  .van-button{
    width: 33.3%;
    border: 1px #f4f4f4 solid;
  }
}
.footer2{
  display: flex;
  margin-top: -10px;
  .van-button{
    width: 50%;
    border: 1px #f4f4f4 solid;
  }
}

.vant-table{
  margin-top: 15px;
  background-color: #fff;
  // padding: 20px;
  padding-bottom: 120px;
  /deep/ .van-cell{
    padding: 20px 10px 20px 30px;
  }
  .table {
    border: 2px solid #ddd;
    line-height: 65px;
    font-size: 28px;
    text-align: center;
    color: #666;
    .th {
      font-weight: 400;
      border-right: 2px solid #ddd;
    }
    .th:last-child {
      border-right: none;
    }
    .list-tr{
      /deep/ .van-field__label{
        width: 30px;
      }
    }
    .list-tr:hover {
      background-color: #f5f5f5;
    }
    td {
      border-top: 2px solid #ddd;
      border-right: 2px solid #ddd;
    }
    td:last-child {
      border-right: none;
    }
  }
}
/deep/ .van-step--finish .van-step__circle{
  background-color: #1989fa;
}
/deep/ .van-step--finish .van-step__line{
  background-color: #1989fa;
}
</style>
